import React from 'react';
import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import './styles/index.css';
import './styles/parts.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { SharedInfoContextProvider } from './components/SharedInfoContextProvider';
// import ErrorBoundary from './components/ErrorBoundary';
import { SDKProvider } from "./scandit/sdk";
import { StoreProvider } from "./scandit/store";
// import * as serviceWorker from './serviceWorker';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SDKProvider>
	<StoreProvider>
	<SharedInfoContextProvider>
		<App />
	</SharedInfoContextProvider>
	</StoreProvider>
	</SDKProvider>
);

// reportWebVitals();

// PWA用にService Workerを登録
// serviceWorker.register();
// serviceWorkerRegistration.register();
